/** All possible types of objects that 1C can load into the FRM */
export enum Erp1cObjectTypeEnum {
  /** Invoice (bill in FRM) */
  INVOICE = 'invoice',
  /** Payment order (BRS task order in FRM) */
  PAYMENT_ORDER = 'paymentOrder',
  /** Sale document */
  SALE = 'sale',
  /** Purchase document */
  PURCHASE = 'purchase',
  /** Buyer return document */
  BUYER_RETURN = 'buyerReturn',
  /** Supplier return document */
  SUPPLIER_RETURN = 'supplierReturn',
  /** Receipt on account document */
  RECEIPT_ON_ACCOUNT = 'receiptOnAccount',
  /** Expense from account document */
  EXPENSE_FROM_ACCOUNT = 'expenseFromAccount',
  /** Receipt on cash document */
  RECEIPT_ON_CASH = 'receiptOnCash',
  /** Expense from cach document */
  EXPENSE_FROM_CASH = 'expenseFromCash',
  /** Sale correction document */
  SALE_CORRECTION = 'saleCorrection',
}
